import { render, staticRenderFns } from "./boaiRY.vue?vue&type=template&id=02508100&scoped=true"
import script from "./boaiRY.vue?vue&type=script&lang=js"
export * from "./boaiRY.vue?vue&type=script&lang=js"
import style0 from "./boaiRY.vue?vue&type=style&index=0&id=02508100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02508100",
  null
  
)

export default component.exports